import request from '@/utils/request'

// 获取商户列表
export const postShopList = function (data) {
    return request({
        url: '/api/shop/list',
        method: 'post',
        data: data
    })
}

// 店铺基本信息
export const applyInfo = function (data) {
    return request({
        url: '/api/shop/applyInfo',
        method: 'post',
        data: data
    })
}

// 申请店铺
export const apply = function (data) {
    return request({
        url: '/api/shop/apply',
        method: 'post',
        data: data
    })
}

// 申请店铺new
export const applyNew = function (data) {
    return request({
        url: '/api/shop/applyNew',
        method: 'post',
        data: data
    })
}

// 编辑店铺
export const applyEdit = function (data) {
    return request({
        url: '/api/shop/applyEdit',
        method: 'post',
        data: data
    })
}

// 编辑店铺
export const shopEdit = function (data) {
    return request({
        url: '/api/shop/shopEdit',
        method: 'post',
        data: data
    })
}

// 编辑店铺自由营业时间
export const shopEditHours = function (data) {
    return request({
        url: '/api/shop/shopEditHours',
        method: 'post',
        data: data
    })
}

// 营业时间
export const shopHours = function (data) {
    return request({
        url: '/api/hours/getInfo',
        method: 'post',
        data: data
    })
}

// 营业时间修改
export const shopHoursEdit = function (data) {
    return request({
        url: '/api/hours/hoursSave',
        method: 'post',
        data: data
    })
}

// 统计报表
export const shopOrderReport = function (data) {
    return request({
        url: '/api/shop/report',
        method: 'post',
        data: data
    })
}
export const shopFoodReport = function (data) {
    return request({
        url: '/api/shop/foodReport',
        method: 'post',
        data: data
    })
}

export const shopCopy = function (data) {
    return request({
        url: '/api/shop/shopCopy',
        method: 'post',
        data: data
    })
}

export const shopDiscount = function () {
    return request({
        url: '/api/shop/discount',
        method: 'get',
    })
}

// 运费
export const shopDistance = function () {
    return request({
        url: '/api/shop/distance',
        method: 'get',
    })
}

// 运费编辑
export const shopDistanceEdit = function (data) {
    return request({
        url: '/api/shop/distanceEdit',
        method: 'post',
        data: data
    })
}

// 运费删除
export const shopDistanceDel = function (data) {
    return request({
        url: '/api/shop/distanceDel',
        method: 'post',
        data: data
    })
}

export default {
    postShopList,
    applyInfo,
    apply,
    applyNew,
    applyEdit,
    shopEdit,
    shopEditHours,
    shopOrderReport,
    shopFoodReport,
    shopDistance,
    shopDistanceEdit,
    shopDistanceDel,

    shopHours,
    shopHoursEdit,
    shopCopy,
    shopDiscount
}
